module.exports = __webpack_public_path__ + "static/media/Well-being.45b9402e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/Well-being.svg
// module id = 569
// module chunks = 1